<template>
	<v-dialog v-model="showDialog" :max-width="modalWidth" persistent>
		<v-card>
			<v-card-text class="text-center">{{
				message || 'Are you sure?'
			}}</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn v-if="showOkBtn" @click.stop="okOk()" color="primary">{{
					'Ok'
				}}</v-btn>
				<v-spacer />
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	name: 'MessageDialog',
	props: {
		showDialog: Boolean,
		message: String,
		showOkBtn: Boolean,
		modalWidth: String,
	},
	methods: {
		okOk() {
			this.$emit('ok');
		},
	},
};
</script>
